import CreateItemResponse from "../types/CreateItemResponse";
import axiosInstance from "./axiosInstance";
import MediatorRequest from "../types/MediatorRequest";
import MediatorsResponse from "../types/MediatorsResponse";
import AddMediatorScore from "../types/AddMediatorScore";
import MediatorScoresResponse from "../types/MediatorScoresResponse";
import ScoresResponse from "../types/ScoresResponse";
import {getParams} from "./util";
import ScoreFiltersResponse from "../types/ScoreFiltersResponse";
import EditMediatorRequest from "../types/EditMediatorRequest";

export const createMediator = async (request: MediatorRequest): Promise<CreateItemResponse | void> => {
    return axiosInstance.post<CreateItemResponse>("/mediators", request)
        .then(response => response.data)
        .catch(error => error.response.data)
}

export const fetchMediators = async (params: any): Promise<MediatorsResponse | void> => {
    const queryParams = getParams(params);
    return axiosInstance.get<MediatorsResponse>(`/mediators${queryParams}`)
        .then(response => response.data)
        .catch(error => error.response.data)
}

export const editMediator = async (mediatorId: number, request: EditMediatorRequest) =>
    axiosInstance.patch<MediatorsResponse>(`/mediators/${mediatorId}`, request)
        .then(response => response.data)
        .catch(error => error.response.data)

export const addMediatorScore = async (mediatorId: number, request: AddMediatorScore): Promise<any> => {
    return axiosInstance.post<any>(`/mediators/${mediatorId}/scores`, request)
        .then(response => response)
        .catch(error => {
            throw error
        })
}

export const fetchMediatorScores = async (params: any): Promise<MediatorScoresResponse | void> => {
    const queryParams = getParams(params);
    return axiosInstance.get<MediatorScoresResponse>(`/mediators/scores${queryParams}`)
        .then(response => response.data)
        .catch(error => error.response.data)
}

export const fetchScoreStatistics = async (params: any): Promise<ScoresResponse | void> => {
    const queryParams = getParams(params);
    return axiosInstance.get<ScoresResponse>(`/mediators/scores/statistics${queryParams}`)
        .then(response => response.data)
        .catch(error => error.response.data)
}

export const fetchScoreFilters = async (): Promise<ScoreFiltersResponse | void> => {
    return axiosInstance.get<ScoresResponse>("/mediators/scores/statistics/filters")
        .then(response => response.data)
        .catch(error => error.response.data)
}

export const downloadScoresExcel = async (params: any): Promise<any | void> => {
    const queryParams = getParams(params);
    return axiosInstance.get<any>(`/mediators/scores/statistics/excel${queryParams}`, {
        responseType: 'blob',
    })
        .then(response => response.data)
        .catch(error => error.response.data)
}
